import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import CourseDetailsComp from './CourseDetailsComp'

function CourseDetails() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu/>
        <div className='theMainContainer'>
          <Dashnav/>
              <AdmissionTopNotice/>
          <CourseDetailsComp/>
        </div>
      </div>
    </div>
  )
}

export default CourseDetails
